import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Avatar, message } from 'antd';

import { Button, Icon as CroplerIcon } from '@cropler/ui-kit';

import styles from './styles.module.scss';
import emptyUserAvatar from '../../assets/images/avatar.png';

import { getBase64 } from '../../utils/files';
import { useViewport } from '../../hooks';
import { BreakpointMobile } from '../../constants/ui';
import { getFirstLetter } from '../../utils/ui.tsx';

export const UploadAvatar = ({ imageUrl = '', text = '', showUserAvatar, changeImage }) => {
  const { t } = useTranslation();
  const [avatarBase64, setAvatarBase64] = useState();
  const [removed, setRemoved] = useState(false);
  const { widthViewport } = useViewport();

  const currentImage = removed ? '' : avatarBase64 || imageUrl;

  const onChangeAvatar = (value) => {
    const file = value.target.files[0];

    const isCorrectType = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
    if (!isCorrectType) {
      message.error(t('uploadAvatar.errorFileType'));
      return;
    }

    const isCorrectSize = file.size / 1024 / 1024 < 5;
    if (!isCorrectSize) {
      message.error(t('uploadAvatar.errorFileSize'));
      return;
    }

    if (isCorrectSize && isCorrectType) {
      let isCorrectWidthHeight = false;
      getBase64(value.target.files[0], (url) => {
        const img = new Image();
        img.src = url;
        img.onload = () => {
          isCorrectWidthHeight = img.naturalWidth < 2049 && img.naturalHeight < 2049;
          if (!isCorrectWidthHeight) {
            message.error(t('uploadAvatar.errorImageSize'));
          } else {
            setAvatarBase64(url);
          }
        };
      });
    }

    setRemoved(false);

    return changeImage(file);
  };

  const onRemoveAvatar = () => {
    setAvatarBase64(null);
    setRemoved(true);
    return changeImage('');
  };

  return (
    <div className={styles.avatar}>
      <label className={styles.avatarUpload}>
        <Avatar size={48} src={currentImage || (showUserAvatar ? emptyUserAvatar : '')} alt={text}>
          {!!text && getFirstLetter(text)}
        </Avatar>
        <input type="file" onChange={onChangeAvatar} />
        {widthViewport > BreakpointMobile && (
          <span className={styles.avatarUploadButton}>
            <CroplerIcon name="upload" />
            {t('uploadAvatar.button')}
          </span>
        )}
      </label>
      {!!currentImage && (
        <Button
          type="secondary"
          icon={<CroplerIcon name="remove" />}
          shape="circle"
          onClick={onRemoveAvatar}
          className={styles.avatarRemoveButton}
        />
      )}
    </div>
  );
};
